import { LocationStrategy } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBaseModel } from '../models/base.model';
import { ICriterioModel } from '../models/criterio.model';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root',
})
export class CriterioService extends BaseService {

  constructor(httpClient: HttpClient, locationStrategy: LocationStrategy) {
    super(httpClient, locationStrategy);
  }

  public obter(pesquisa: string, ativo: boolean, simplificado = false): Promise<IBaseModel<ICriterioModel[]>> {
    let params = new HttpParams();
    params = params.append('pesquisa', pesquisa || '');

    if (ativo !== undefined) {
      params = params.append('ativo', ativo.toString());
    }

    if (simplificado) {
      params = params.append('simplificado', simplificado.toString());
    }

    return this.httpClient
      .get<IBaseModel<ICriterioModel[]>>(`${this.apiBaseUrl}/criterio`, { params })
      .toPromise();
  }

  public async obterPorId(id: number): Promise<IBaseModel<ICriterioModel>> {
    return this.httpClient
      .get<IBaseModel<ICriterioModel>>(`${this.apiBaseUrl}/criterio/${id}`)
      .toPromise();
  }

  public async inserir(data: ICriterioModel): Promise<IBaseModel<void>> {
    return this.httpClient
      .post<IBaseModel<void>>(`${this.apiBaseUrl}/criterio`, data)
      .toPromise();
  }

  public async atualizar(data: ICriterioModel): Promise<IBaseModel<void>> {
    return this.httpClient
      .put<IBaseModel<void>>(`${this.apiBaseUrl}/criterio/${data.id}`, data)
      .toPromise();
  }

  public async reativar(id: number): Promise<IBaseModel<void>> {
    return this.httpClient
      .post<IBaseModel<void>>(`${this.apiBaseUrl}/criterio/${id}/reativar`, {})
      .toPromise();
  }

  public async inativar(id: number): Promise<IBaseModel<void>> {
    return this.httpClient
      .post<IBaseModel<void>>(`${this.apiBaseUrl}/criterio/${id}/inativar`, {})
      .toPromise();
  }
  public async excluirCriterio(id: number): Promise<IBaseModel<void>> {
    return this.httpClient
      .delete<IBaseModel<void>>(`${this.apiBaseUrl}/criterio/${id}/excluir`, {})
      .toPromise();
  }
}
